import { getApiActionTypes } from '../storeHelpers';

export const fetchAccountDetailsTypes = getApiActionTypes('FETCH_ACCOUNT_DETAILS');
